// Totals (job page round): an invoice's sums under its lines, at the end of the column: subtotal, tax,
// total, each payment taken off, then what's owing, heavier over a rule. Labels at the start, figures
// at the end in tabular figures; a payment reads as a minus. Reads only --totals-*.
import type { ReactNode } from 'react';
import './Totals.css';

export interface TotalsRow {
  label: ReactNode;
  value: ReactNode;
  /** strong: the total; due: what's owing, over a rule; muted: a note ("nothing owing"). */
  kind?: 'strong' | 'due' | 'muted';
}
export interface TotalsProps {
  rows: TotalsRow[];
  /** What they're the sums of, for screen readers ("INV-18402’s totals"). */
  label: string;
}

export function Totals({ rows, label }: TotalsProps) {
  return (
    <dl className="fl-totals" aria-label={label}>
      {rows.map((r, i) => (
        <div key={i} className="fl-totals__row" data-kind={r.kind}>
          <dt className="fl-totals__label">{r.label}</dt>
          <dd className="fl-totals__value">{r.value}</dd>
        </div>
      ))}
    </dl>
  );
}
